import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { ScopeContext } from './wizard-scope-context';
/**
 * Used to store any temporary state needed for the signup wizard.
 */
export const WizardContext = React.createContext();

export const WizardContextProvider = (props) => {
  const { wizardContext, setWizardContext } = props;
  const [, setScopeContext] = useContext(ScopeContext);

  useEffect(() => {
    setScopeContext({
      campaignId: wizardContext.campaignId,
      adgroupId: wizardContext.adgroupId,
    });
  }, [setScopeContext, wizardContext.adgroupId, wizardContext.campaignId]);

  return (
    <WizardContext.Provider value={[wizardContext, setWizardContext]}>
      {props.children}
    </WizardContext.Provider >
  );
};

WizardContextProvider.propTypes = {
  wizardContext: PropTypes.shape({}).isRequired,
  setWizardContext: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
